export default "__VITE_ASSET__C2U5fL2___"